import { RemoteParams, SearchParam, UserFavoriteData } from '../http/RemoteParams';
import { LOAD_DATA_TYPE } from '../lookup-grid-options';
import { LookupGridComponent } from '../lookup-grid.component';
import { cloneDeep } from 'lodash-es';
import { FavoriteAction, FAVORITE_FIELD_NAME, LookupGridDisplayType } from '../lookup-displaytype';
import { Observable, of, forkJoin } from 'rxjs';
import { map, switchMap, tap, debounceTime } from 'rxjs/operators';
import { Compare, FilterRelation } from '@farris/ui-common/types';
import { flatten } from 'lodash-es';

// å¸®å©é»è®¤ä¸ªæ§åæ°æ®
const DefaultUserConfig = {
    tabIndex: 'datalist',
    favorite: null,
    size: null
};
export class LookupHttpManager {
    // æ¯æ¬¡å¸®å©æå¼åï¼æ´æ°æ­¤å¼ï¼åä¸ºä¸ªæ§åæ°æ®çåå§å¼ï¼
    // å³é­çªå£æ¶ï¼ä¸æ­¤è¿è¡å¯¹æ¯ãå¦æä¸æ ·ï¼åä¸ä¿å­ï¼
    private _originalPersonalConfig = DefaultUserConfig;

    constructor(private ins: LookupGridComponent) { }

    private disablePagination() {
        return {
            pageIndex: 1,
            pageSize: 500
        };
    }

    private searchAnyFields(searchValues: string, isNavSearch = false, searchType = 'like'): any[] {
        // å¤çç©ºå¼æåªåå«ç©ºæ ¼çæåµ
        if (!searchValues.trim()) {
            return [];
        }
    
        const fields = !isNavSearch ? this.ins.gridOptions.searchFields : this.ins.navigationOptions.searchFields;
        const searchKeys = Array.from(new Set(searchValues.trim().split(' ').filter(n => n.trim())));
    
        // å¦ææ²¡ææç´¢å­æ®µææç´¢å³é®å­ï¼åç´æ¥è¿åç©ºæ°ç»
        if (!fields || !searchKeys.length) {
            return [];
        }

        const compare = searchType === 'like' ? Compare.Like : Compare.Equal;

        const conditions = (fields || []).map((n: { label: string, value: string }, i) => {
            const fieldConditions = searchKeys.map((s, j) => {
                return {
                    filterField: n.value,
                    value: s,
                    lbracket: '',
                    rbracket: '',
                    relation: FilterRelation.And,
                    compare,
                }
            });
            if (fieldConditions.length) {
                if (fieldConditions.length > 1) {
                    fieldConditions[0].lbracket = '(';
                    fieldConditions[fieldConditions.length - 1].rbracket = ')';
                }

                fieldConditions[fieldConditions.length - 1].relation = FilterRelation.Or;
            } 
            return fieldConditions
        }).filter(n => n.length);

        let _conditions = [];
        if (conditions && conditions.length) {
            _conditions = flatten(conditions);
            if (_conditions.length) {
                if (_conditions.length > 1) {
                    _conditions[0].lbracket += '(';
                    _conditions[_conditions.length - 1].rbracket += ')';
                }
                _conditions[_conditions.length - 1].relation = 0;
            }
        }

        return _conditions;
    }

    /** æé æ¥è¯¢åæ° */
    buildQueryParams(event?: any, type: LOAD_DATA_TYPE = 'all') {
        const params: RemoteParams = {};

        if (event.navConditions && event.navConditions.length) {
            if (event.navConditions && event.navConditions.length === 1 && event.navConditions[0].code == '*') {
                event.search = { field: '*', value: event.navConditions[0].value};
            } else {
                params.navSearchConditions = event.navConditions;
            }
        }

        if (this.ins.conditions && this.ins.conditions.length && type !== 'fav') {
            params.searchConditions = cloneDeep(this.ins.conditions);
        }

        const searchParam: SearchParam = { category: type };

        if (type !== 'fav') {
            if (this.ins.isDoublleList() && this.ins.navigationFilter && type !== 'all') {
                if (this.ins.navigationFilter.idValue && type !== 'textchange') {
                    params.relationFilter = [...this.ins.navigationFilter.idValue];
                }
            }
        }

        if (event) {
            if (type === 'fav' || type === 'selected') {
                event.pageInfo = this.disablePagination();
            }

            if (event.pageInfo) {
                params.pageIndex = event.pageInfo.pageIndex;
                params.pageSize = event.pageInfo.pageSize;
            }

            if (event.search) {
                let sfield = event.search.field;
                if (sfield && sfield === '*') {
                    sfield = '*';
                }

                if (event.search.value) {
                    event.search.value = event.search.value.trim();
                }

                const setSearchAnyFields = () => {
                    searchParam.searchField = sfield;
                    searchParam.searchValue = event.search.value;
                    searchParam.searchType =  event.search.type || this.ins['searchType'] || 'like';
                }

                setSearchAnyFields();
                // tfs 645388
                if (!this.ins.enableMultiFieldSearch && sfield == '*') {
                    const isNavSearch = searchParam.category == 'navsearch';
                    const conditions = this.searchAnyFields(event.search.value, isNavSearch, searchParam.searchType);
                    if (conditions && conditions.length) {
                        if (isNavSearch) {
                            params.navSearchConditions = conditions
                        } else {
                            params.searchConditions = conditions;
                        }
                    }
                }

                if (event.search.value === '' && searchParam.category === 'search' && (!params.searchConditions && !params.navSearchConditions)) {
                    searchParam.category = 'all';
                }
            }

            if (event.sortName) {
                // tfs 639865
                const col = this.ins.columns.find(n => n.field === event.sortName);
                const _sortName = col ? col.fieldPath ? col.fieldPath : col.field : event.sortName;
                searchParam.sortName = _sortName;
            }
            if (event.sortOrder) {
                searchParam.sortOrder = event.sortOrder;
            }

            if (this.ins.isTree()){
                if (this.ins.isEnableTreePager()) {
                    params['enableTreePagination'] = true;
                }

                // åå±å è½½æ¯æè®¾ç½®å±å¼å±çº§
                if (!isNaN(Number(event.expandLevel)) && !params['enableTreePagination']) {
                    // åç«¯ -1 ä¸å±å¼   0 å¨å±å¼
                    // åç«¯  0 ä¸å±å¼  -1 å¨å±å¼
                    if (event.expandLevel) {
                        if (event.expandLevel === -1) {
                            event.expandLevel = 0;
                        }
                    } else {
                        event.expandLevel = -1;
                    }
                    searchParam['layerNum'] = event.expandLevel;
                }

            }
          
        }

        if (type === 'fav' && event.favoriteIds) {
            searchParam.favoriteIds = event.favoriteIds;
        }

        if (this.ins.isTree() || this.ins.displayType === LookupGridDisplayType.NavTreeList) {
            params.enableFullTree = this.ins.enableFullTree;
        }

        params.treeToList = this.ins.treeToList;
        params.navTreeToList = this.ins.navTreeToList;

        // æ¥è¯¢æ¶ä¸æé å®æ´æ 
        if (type === 'textchange') {
            params.enableFullTree = false;
        }

        if (type === 'selected') {
            searchParam.category = 'fav';
            params.enableFullTree = false;
            searchParam.favoriteIds = event.favoriteIds;
        }

        params.searchValue = JSON.stringify(searchParam);
        params.loadTreeDataType = this.ins.loadTreeDataType;

        params.customData = this.ins.customData;

        if (this.ins.helpId) {
            params.helpId = this.ins.helpId;
        }

        if (event.selectedInfo) {
            params.selectedInfo = event.selectedInfo;
        }

        if (event.navNodePathCode !== undefined) {
            params.navPathCode = event.navNodePathCode;
        } else {
            if (type === 'navAllChildren') {
                if (this.ins.includeSubordinates && this.ins['navNodePathCode']) {
                    params.navPathCode = this.ins['navNodePathCode'];
                }
            }
        }

        return params;
    }

    getData(event?: any, type: LOAD_DATA_TYPE = 'all'): Observable<any> {
        const uri = this.ins.gridOptions.uri;

        if (this.ins.isDoublleList() &&  this.ins.navigationFilter && this.ins.navigationFilter.idValue && type !== 'fav') {
            if (this.ins.includeSubordinates && this.ins.navigationOptions.treeInfo.loadDataType === 'async') {
                type = 'navAllChildren';
            } else {
                type = 'list';
            }
        }

        const params = this.buildQueryParams(event, type);

        if (uri || this.ins.beUri) {
            if (this.ins.beUri && this.ins.columns && this.ins.columns.length) {
                const allSearchFields = this.ins.columns.map(col => col.searchField).filter(f => f);
                if (!params.condition) {
                    params.condition = {};
                }

                if (!this.ins.isTree() && this.ins.pagination) {
                    const { pageSize = this.ins.pageSize || 20, pageIndex } = { ...params };
                    params.condition.pagination = { pageSize, pageIndex };
                } else {
                    params.condition.pagination = { isUsePagination: false };
                }
                const searchParam = JSON.parse(params.searchValue);
                if (searchParam.searchValue) {
                    params.condition = this.ins.lookupUtils.mergeCondition(params.condition, allSearchFields, {
                        field: searchParam.searchField,
                        value: searchParam.searchValue
                    });
                }
            }

            const _uri = this.ins.beUri || uri;

            if (this.ins.http) {
                this.ins.http.context = this.ins.context;
            }
            if (this.ins._searchResult) {
                return of(this.ins._searchResult);
            }

            if (type !== 'allChildren') {
                return this.ins.http.getData(_uri, params);
            } else {
                const params1 = {
                    searchValue: JSON.stringify({ category: type }),
                    parentsIds: event.parentsIds,
                    customData: params.customData,
                    helpId: params.helpId
                };
                return this.ins.http.getData(_uri, params1);
            }
        } else {
            return of(false);
        }
    }

    // getFavoriteData(params) {
    //     return this.getData(params, 'fav');
    // }

    getSelecedItems(selIds: any[]) {
        return this.getData({ favoriteIds: selIds }, 'selected');
    }

    getPersonalConfig() {
        const defaultConf = cloneDeep(DefaultUserConfig);
        
        // if (this.ins.customData) {
        //     const wrapKeyData = JSON.stringify({ key: this.ins.customData });
        //     const configKeyString = this.ins.getLookupBindingFields() + wrapKeyData;
        //     this.ins.personalConfigService.personalConfigKey = configKeyString;
        // }
        let key = this.ins.personalConfigService._newKey;
        if (this.ins.favoriteKey) {
            key = this.ins.favoriteKey;
        }

        let _conf = this.ins.personalConfigService.getPersonalData(key);

        if (!_conf || !Object.keys(_conf).length) {
            _conf = defaultConf;
        }
        const req = of(_conf);

        if (this.ins.favoriteDataFrom === 'locale' || this.ins.isTabChanged) {
            return req;
        }

        if (this.ins.http && this.ins.http['getUserSettings']) {
            return this.ins.http['getUserSettings'](key).pipe(
                tap((r: any) => { // TFS 611953
                    if (r && r.textValue) {
                        localStorage.setItem(key, r.textValue);
                    } else {
                        localStorage.setItem(key, JSON.stringify(defaultConf));
                    }
                }),
                map((ucs: any) => {
                    if (ucs) {
                        return ucs.textValue ? JSON.parse(ucs.textValue) : defaultConf;
                    }
                    return defaultConf;
                })
            );
        } else {
            return req;
        }
    }

    private checkActiveTab() {
        if (!this.ins.useFavorite) {
            this.ins.activeTab = 'datalist';
        }
    }

    lookupRequest(event?: any, type: LOAD_DATA_TYPE = 'all', isQuickSelect = false) {
        this.checkActiveTab();

        if (!this.ins.usePersionalConf || isQuickSelect) {
            return this.getData(event, type);
        }

        const req = this.getPersonalConfig();

        return req.pipe(
            tap((c: any) => {
                this.ins.personalConf = c;
                this.ins.personalConfigService.savePersonalConfig(c);
                if (!this.ins.isTabChanged) {
                    this._originalPersonalConfig = cloneDeep(c);
                }
            }),
            switchMap((c: any) => {
                const { tabIndex, favorite, size, cascadeStatus } = c;

                if (!this.ins.isTabChanged) {
                    this.ins.activeTab = tabIndex || 'datalist';
                }

                // å¯ç¨ä¸ªæ§åæ°æ®ï¼æ°æ®ä¸­å¯ç¨æ¶èå¤¹ï¼èç»ä»¶æªå¯ç¨æ¶é¡»è®¾ç½® activeTab ä¸º datalist
                this.checkActiveTab();

                if (size) {
                    this.ins.dialogWidth = size.width;
                    this.ins.dialogHeight = size.height;

                    if (!this.ins.isTabChanged) {
                        this.ins.dialog.reSize({ width: size.width, height: size.height });
                    }
                }


                if ( this.ins.cascadeStatus) {
                    if (cascadeStatus && this.ins.enableCascade && this.ins.showCascadeControl) {
                        this.ins.cascadeStatus = cascadeStatus;
                    }

                    if (this.ins.cascadeItems) {
                        const keys = ['enable', 'up', 'down', 'disable'];
                        keys.forEach(n => {
                            if (this.ins.cascadeItems[n] === undefined) {
                                this.ins.cascadeItems[n] = true;
                            }
                        });

                        if (!this.ins.cascadeItems[this.ins.cascadeStatus] ) {
                            const keys = Object.keys(this.ins.cascadeItems).map(n => {
                                return this.ins.cascadeItems[n] ? n: '';
                            }).filter(n => n);
                            this.ins.cascadeStatus = keys[0] as any;
                        }
                    }
                }

                if (this.ins.activeTab === 'datalist') {
                    return this.getData(event, type);
                } else if (this.ins.activeTab === 'favorite') {
                    const favIds = favorite ? favorite[this.ins.localService.localeId] : [];
                    if ((!favIds || !favIds.length) && !this.ins.isTabChanged) {
                        return this.getData(event, 'all').pipe(
                            map(r => {
                                if (r && !r.items) {
                                    r.items = [];
                                }
                                r.activeTab = 'datalist';
                                return r;
                            })
                        );
                    }

                    // const _fids = favIds.filter(n => n);
                    event.favoriteIds = favIds;
                    event.search = null;
                    return this.getData(event, 'fav').pipe(
                        switchMap(r => {
                            const items = r ? r.items || [] : [];
                            // å å¥æ°æ®æéåï¼æ²¡æè¿åæ°æ®ä¸ç¬¬1æ¬¡æå¼çªå£ï¼éæå¨ç¹å»æ¶èæ ç­¾æ¶
                            if (!items.length && !this.ins.isTabChanged) {
                                return this.getData(event, 'all').pipe(
                                    map(a => {
                                        if (a && !a.items) {
                                            a.items = [];
                                        }
        
                                        a.activeTab = 'datalist';
                                        return a;
                                    })
                                );
                            } else {
                                return of(r);
                            }
                        })
                    );
                } else if (this.ins.activeTab === 'selected') {
                    const selIds = this.ins.displayValue ? this.ins.displayValue.split(',') : [];
                    const _sids = selIds.filter(n => n);
                    return this.getSelecedItems(_sids);
                }
            })
        );
    }

    // ä¿å­ä¸ªæ§åæ°æ®
    submitFavoriteData(action: any | FavoriteAction) {

        // ä¿å­åå®½åº¦
        this.ins.personalConf.colSizeInfo = this.getColumnSizeInfo();

        // å¦ææ°æ®ä¸é»è®¤çæ°æ®ä¸è³åä¸ä¿å­ã
        if (JSON.stringify(this.ins.personalConf) === JSON.stringify(this._originalPersonalConfig)) {
            return;
        }

        let msg = '';
        if (action === FavoriteAction.add) {
            msg = this.ins.addFavoriteSuccess;
        } else if (action === FavoriteAction.delete) {
            msg = this.ins.delFavoriteSuccess;
        }
        // æ´æ°æ¬å°ç¼å­
        localStorage.setItem(this.ins.personalConfigService._newKey, JSON.stringify(this.ins.personalConf));
        this.ins.personalConfigService.savePersonalConfig(this.ins.personalConf || {});

        if (this.ins.favoriteDataFrom !== 'locale') {
            this._originalPersonalConfig = cloneDeep(this.ins.personalConf);

            const configData: UserFavoriteData = {
                configkey1: this.ins.personalConfigService.personalConfigKey,
                configkey2: '',
                configkey3: '',
                textvalue: JSON.stringify(this.ins.personalConf)
            };

            if (this.ins.http && this.ins.http['saveUserSettings']) {
                this.ins.savingFaoriteData = true;
                this.ins.showLoading();
                return this.ins.http['saveUserSettings'](configData).subscribe((r) => {
                    this.ins.savingFaoriteData = false;
                    this.ins.closeLoading();
                    if (msg) {
                        this.ins.notifyService.success(msg);
                    }
                });
            } else {
                if (msg) {
                    this.ins.notifyService.success(msg);
                }
            }
        } else {
            if (msg) {
                this.ins.notifyService.success(msg);
            }
        }
    }

    private getColumnSizeInfo() {
        const colSizeInfo = {data: {}, nav: {}, fav: {}, sel: {}};
        colSizeInfo.data = this.ins.columns.filter((c) => c.field !== FAVORITE_FIELD_NAME).reduce((r, n) => {
            r[n.field] = n.width;
            return r;
        }, {});

        if (this.ins.favoriteColumns && this.ins.favoriteColumns.length) {
            colSizeInfo.fav = this.ins.favoriteColumns.filter((c) => c.field !== FAVORITE_FIELD_NAME).reduce((r, n) => {
                r[n.field] = n.width;
                return r;
            }, {});
        }

        if (this.ins.navigationOptions && this.ins.navigationOptions.columns && this.ins.navigationOptions.columns.length) {
            colSizeInfo.nav = this.ins.navigationOptions.columns.filter((c) => c.field !== FAVORITE_FIELD_NAME).reduce((r, n) => {
                r[n.field] = n.width;
                return r;
            }, {});
        }

        if (this.ins.selectedColumns && this.ins.selectedColumns.length && this.ins.showSelected) {
            colSizeInfo.sel = this.ins.selectedColumns.filter((c) => c.field !== FAVORITE_FIELD_NAME).reduce((r, n) => {
                r[n.field] = n.width;
                return r;
            }, {});
        }
        
        return colSizeInfo;
    }

}
